import { shuffle } from 'lodash';

class TextureManager {
  constructor() {
    this._textureDegrees = [15, 30, 45, 60, 75, 90, -15, -30, -45, -60, -75, -90];
    this.textureRaster = null;
    this.canvas = null;
  }

  initializeTexture(textureType, paperInstance, canvasEl) {
    this.canvas = canvasEl;
    const raster = new paperInstance.Raster(textureType);

    raster.opacity = 0;

    return new Promise(resolve => {
      raster.onLoad = () => {
        this.textureRaster = raster;
        resolve(raster);
      };
    });
  }

  drawDenseTexturePoint({ x, y }) {
    for (let i = 0; i < 3; i++) {
      this.drawTexturePoint({ x, y }, 1);
    }
  }

  drawTexturePoint({ x, y }, index) {
    const raster = this.textureRaster.clone();
    const { width: canvasWidth } = this.canvas.getBoundingClientRect();
    const textureRadius = (4.3 / 100) * canvasWidth;
    if (index && index % 5 !== 0) {
      raster.setWidth(textureRadius);
      raster.setHeight(textureRadius);
      raster.rotate(shuffle(this._textureDegrees)[0]);
      raster.position = { x, y };
      raster.opacity = 1;

      raster.position = { x, y };
    }
  }
}

export default new TextureManager();
